import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { ContactMessageStore } from '@seedlang/stores';
import ReactJson from 'react-json-view';
import { isPresent } from '@seedlang/utils';
import Button from 'components/button/button';
import { Link } from 'react-router';
import Copy from 'components/copy';
import { computed } from 'mobx';
import isBlank from 'is-blank';

const Wrapper = styled.div`

`;

const FieldLabel = styled.div`
  font-weight: bold;
  margin-top: 10px;
`;

@observer
class ContactMessageShow extends React.Component {

  componentDidMount() {
    ContactMessageStore.getShow({ ids: { contactMessageId: this.props.params.contactMessageId } });
  }

  @computed get isReviewDeck() {
    return ContactMessageStore.showData?.debugInfoJson?.['deck_info']?.['deck_type'] === 'review';
  }

  @computed get deckId() {
    return ContactMessageStore.showData?.debugInfoJson?.['deck_info']?.['deck_id'];
  }

  @computed get userId() {
    return ContactMessageStore.showData?.userId;
  }

  @computed get currentAnimationCard() {
    if (!ContactMessageStore.hasShowData || isBlank(ContactMessageStore.showData.debugInfoJson) || isBlank(ContactMessageStore.showData.debugInfoJson['animation_cards'])) { return; }
    return ContactMessageStore.showData.debugInfoJson['animation_cards'][0];
  }

  @computed get currentCard() {
    if (!ContactMessageStore.hasShowData || isBlank(ContactMessageStore.showData.debugInfoJson) || isBlank(ContactMessageStore.showData.debugInfoJson['cards'])) { return; }
    return ContactMessageStore.showData.debugInfoJson['cards'].find(card => card.id === this.currentAnimationCard['card_id']);
  }

  @computed get sourceDeckId() {
    return this.currentCard?.['source_deck_id'];
  }

  render() {
    return (
      <Wrapper>
        <fieldset>
          <legend>Email</legend>
          {ContactMessageStore.showData.email}
        </fieldset>
        <fieldset>
          <legend>Message</legend>
          {ContactMessageStore.showData.message}
        </fieldset>
        <fieldset>
          <legend>Image</legend>
          {
            ContactMessageStore.showData.imageUrl &&
            <img
              src={ContactMessageStore.showData.imageUrl}
              alt=''
            />
          }
        </fieldset>
        <fieldset>
          <legend>Debug Info</legend>
          {
            ContactMessageStore.hasShowData && isPresent(ContactMessageStore.showData.debugInfoJson) &&
            <div>
              {
                this.currentAnimationCard &&
                <div
                  style={{ marginBottom: 10 }}
                >
                  <FieldLabel>
                    Current Card Translation
                  </FieldLabel>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    {this.currentAnimationCard['translation']}
                    {
                      isPresent(this.currentAnimationCard['translation_id']) && isPresent(this.currentAnimationCard['translation_type']) && this.currentAnimationCard['card_type'] !== 'exercise' &&
                      <Link
                        className='underline'
                        target='_blank'
                        style={{ marginLeft: '20px', fontSize: '14px' }}
                        to={{ name: this.currentAnimationCard['translation_type'] === 'Sentence' ? 'builder.sentences.edit' : 'builder.words.edit', params: { sentenceId: this.currentAnimationCard['translation_id'], wordId: this.currentAnimationCard['translation_id'] } }}
                      >
                        Edit translation
                      </Link>
                    }
                    <Copy
                      text={this.currentAnimationCard['translation']}
                    />
                  </div>
                  <FieldLabel>
                    Card Type
                  </FieldLabel>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    {this.currentAnimationCard['card_type']}
                  </div>
                  {
                    this.currentAnimationCard['vocab_multiple_choice_options'] &&
                      <div>
                        <FieldLabel>
                          Vocab Multiple Choice Options
                        </FieldLabel>
                        {this.currentAnimationCard['vocab_multiple_choice_options']}
                      </div>
                  }
                  {
                    this.currentAnimationCard['selected_option'] &&
                      <div>
                        <FieldLabel>
                          Selected Option
                        </FieldLabel>
                        {this.currentAnimationCard['selected_option']}
                      </div>
                  }
                  {
                    this.currentAnimationCard['selected_word_associations'] &&
                    <div>
                      <FieldLabel>
                        Selected Words (blanks)
                      </FieldLabel>
                      {this.currentAnimationCard['selected_word_associations']}
                    </div>
                  }
                  {
                    (this.currentCard['text_entry'] || this.currentCard['input_values']) &&
                    <div>
                      <FieldLabel>
                        User Input
                      </FieldLabel>
                      {this.currentCard['text_entry']}
                      {this.currentCard['input_values']}
                    </div>
                  }
                </div>
              }
              <div style={{ display: 'flex', gap: '10px' }}>
                {
                  this.userId &&
                  <Link
                    to={{ name: 'builder.users.edit', params: { userId: this.userId } }}
                  >
                    <Button
                      margin='0 0 10px 0'
                    >
                      Go To User
                    </Button>
                  </Link>
                }
                {
                  !this.isReviewDeck &&
                    <Link
                      to={{ name: 'decks.show', params: { deckId: this.deckId } }}
                    >
                      <Button
                        margin='0 0 10px 0'
                      >
                        Open Deck
                      </Button>
                    </Link>
                }
                {
                  !this.isReviewDeck &&
                    <Link
                      to={{ name: 'builder.decks.edit', params: { deckId: this.deckId } }}
                    >
                      <Button
                        margin='0 0 10px 0'
                      >
                        <i className='fa fa-edit' />
                        Go to Deck Edit
                      </Button>
                    </Link>
                }
                {
                  this.isReviewDeck && this.sourceDeckId &&
                    <Link
                      to={{ name: 'decks.show', params: { deckId: this.sourceDeckId } }}
                    >
                      <Button
                        margin='0 0 10px 0'
                      >
                        Open Source Deck
                      </Button>
                    </Link>
                }
                {
                  this.isReviewDeck && this.sourceDeckId &&
                    <Link
                      to={{ name: 'builder.decks.edit', params: { deckId: this.sourceDeckId } }}
                    >
                      <Button
                        margin='0 0 10px 0'
                      >
                        <i className='fa fa-edit' />
                        Go to Source Deck Edit
                      </Button>
                    </Link>
                }
                {
                  this.isReviewDeck && this.userId &&
                    <Link
                      to={{ name: 'builder.decks.reviews.index', params: { userId: this.userId, deckId: this.deckId } }}
                    >
                      <Button
                        margin='0 0 10px 0'
                      >
                        Go to Review Deck
                      </Button>
                    </Link>
                }
              </div>
              <ReactJson
                src={ContactMessageStore.showData.debugInfoJson}
                displayDataTypes={false}
                displayObjectSize={false}
              />
            </div>
          }
        </fieldset>
        <fieldset>
          <legend>Logs</legend>
          <Copy
            text={ContactMessageStore.showData.logs}
          />
          {ContactMessageStore.showData.logs}
        </fieldset>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(ContactMessageShow);
